import { render, staticRenderFns } from "./SendPresentationWhatsappModal.vue?vue&type=template&id=2bb209df&scoped=true"
import script from "./SendPresentationWhatsappModal.vue?vue&type=script&lang=js"
export * from "./SendPresentationWhatsappModal.vue?vue&type=script&lang=js"
import style0 from "./SendPresentationWhatsappModal.vue?vue&type=style&index=0&id=2bb209df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb209df",
  null
  
)

export default component.exports